"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hideDataInAxiosError = exports.Log = exports.LogError = exports.LogRequestResponse = void 0;
var index_1 = require("../index");
function LogRequestResponse(response) {
    var _a;
    if (!!((_a = index_1.urlsConfig.values) === null || _a === void 0 ? void 0 : _a.DEBUG_MODE)) {
        console.log("HTTP - response");
        console.log(response);
    }
}
exports.LogRequestResponse = LogRequestResponse;
function LogError(response) {
    var _a;
    if (!!((_a = index_1.urlsConfig.values) === null || _a === void 0 ? void 0 : _a.DEBUG_MODE)) {
        console.log("Error - catched");
        console.log(response);
    }
}
exports.LogError = LogError;
// log general messages
function Log(message) {
    var _a;
    if (!!((_a = index_1.urlsConfig.values) === null || _a === void 0 ? void 0 : _a.DEBUG_MODE)) {
        console.log(message);
    }
}
exports.Log = Log;
function hideDataInAxiosError(textReplacement, error, listDataValuesNameToHide, listHeadersValuesNameToHide) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    /**
     * Hide data stored in data and headers config if exist
     *
     * @param textReplacement - Text to use to replace data
     * @param error - Error to treat
     * @param listDataValuesNameToHide - List of data names to hide
     * @param listHeadersValuesNameToHide List of headers names to hide
     *
     * @returns The error with data replaced
     */
    //for each data value to hide, check if it's in and hide it's value
    var responseRequestData = JSON.parse((_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.data) !== null && _c !== void 0 ? _c : "{}");
    listDataValuesNameToHide.forEach(function (dataValueKey) {
        if (dataValueKey in responseRequestData)
            responseRequestData[dataValueKey] = textReplacement;
    });
    //for each header value to hide, check if it's in and hide it's value
    var responseRequestHeaders = (_f = (_e = (_d = error.response) === null || _d === void 0 ? void 0 : _d.config) === null || _e === void 0 ? void 0 : _e.headers) !== null && _f !== void 0 ? _f : {};
    listHeadersValuesNameToHide.forEach(function (headerValueKey) {
        if (headerValueKey in responseRequestHeaders)
            responseRequestHeaders[headerValueKey] = textReplacement;
    });
    if ((_h = (_g = error.response) === null || _g === void 0 ? void 0 : _g.config) === null || _h === void 0 ? void 0 : _h.data)
        error.response.config.data = JSON.stringify(responseRequestData);
    if ((_k = (_j = error.response) === null || _j === void 0 ? void 0 : _j.config) === null || _k === void 0 ? void 0 : _k.headers)
        error.response.config.headers = responseRequestHeaders;
    return error;
}
exports.hideDataInAxiosError = hideDataInAxiosError;
